__turbopack_context__.v({
  "inner": "comparison-table-module-scss-module__gmx4sa__inner",
  "outer": "comparison-table-module-scss-module__gmx4sa__outer",
  "section": "comparison-table-module-scss-module__gmx4sa__section",
  "theme-basic": "comparison-table-module-scss-module__gmx4sa__theme-basic",
  "theme-black": "comparison-table-module-scss-module__gmx4sa__theme-black",
  "theme-pink": "comparison-table-module-scss-module__gmx4sa__theme-pink",
  "theme-turquoise": "comparison-table-module-scss-module__gmx4sa__theme-turquoise",
});
